import { computed } from 'vue';
import { authState } from '@/interfaces/composables/auth/authState';

export function useAuthController() {
  const mode = computed({
    get: () => authState.mode.value,
    set: (v) => (authState.mode.value = v),
  });

  const show = computed({
    get: () => authState.showLoginPopup.value,
    set: (v) => (authState.showLoginPopup.value = v),
  });

  const token = computed({
    get: () => authState.resetPasswordToken.value,
    set: (v) => (authState.resetPasswordToken.value = v),
  });

  return { mode, show, token };
}
